import $ from 'jquery';
import 'bootstrap-multiselect';
import 'rangeslider.js';
import jobTitlesConfig from 'JIX/select2/cv_jobtitles.js';

$(function () {
    let current_page = 1;
    const num_pages = $('.section').length;

    function update_buttons() {
        $('.goon .back, .goon .next, .goon .submit').show();
        $('p.page_display').text(JIX.Gettext.__x("Side {page} ud af {num_pages}", { page: current_page, num_pages: num_pages }));
        if (current_page !== num_pages) {
            $('.goon .submit').hide();
        }
        if (current_page === 1) {
            $('.goon .back').hide();
        }
        if (current_page === num_pages) {
            $('.goon .next').hide();
        }
    }

    function next() {
        if (current_page === num_pages) {
            return false;
        }
        const section = $('#sec-' + current_page);
        section.hide();
        current_page += 1;
        $('#sec-' + current_page).show().get(0).scrollIntoView();
        update_buttons();
        $(this).trigger('blur');
        return false;
    }

    function back() {
        if (current_page > 1) {
            $('#sec-' + current_page).hide();
            current_page -= 1;
            $('#sec-' + current_page).show().get(0).scrollIntoView();
        }
        update_buttons();
        $(this).trigger('blur');
        return false;
    }

    function select_answer() {
        const id = $(this).attr('id');
        const id_suffix = id.substring(14);
        const split_pos = id_suffix.indexOf('_');
        if (split_pos > 0) {
            const answer_value = id_suffix.substring(0, split_pos);
            const answer_key = id_suffix.substring(split_pos + 1);
            const affected_input = $("input#jobjoy_question_input_" + answer_key);
            affected_input.val(answer_value);
            affected_input.trigger('change');
        }
    }

    function sex_change() {
        const $radio = $(this);
        const selected_id = 'box_sex_' + $radio.val();
        const $boxes = $('div.box-sex');
        $.each($boxes, function(i, box) {
            const $box = $(box);
            const box_id = $box.attr('id');
            if (box_id === selected_id) {
                $box.attr('style', 'box-shadow: 0px 1px 5px #18b410;');
            } else {
                $box.removeAttr('style');
            }
        });
    }

    $('.section').hide();
    $('.section .section_error').hide();
    $('#sec-' + current_page).show();
    update_buttons();

    $('.goon .back').on('click', back);
    $('.goon .next').on('click', next);

    const jobtitles_config = jobTitlesConfig({
        minimumInputLength: 2,
        maximumSelectionLength: 1,
        showCount: false,
        mode: 'salaryindex',
    });
    $("#jobtitleid").jix_select2(jobtitles_config);

    $('input[type="range"]').rangeslider({ polyfill: false });
    $('span.jobjoy_answer').on('click', select_answer);

    $('input[type="radio"]').on('change', sex_change);

    $('#education').multiselect({
        buttonWidth: '100%',
        buttonClass: '',
        inheritClass: true,
        nonSelectedText: JIX.Gettext.__('Vælg uddannelse'),
        numberDisplayed: 1,
        nSelectedText: 'Valgt',
        allSelectedText: 'Valgt',
        templates: {
            // We use the class sc-multiselect-control-md-ul on ul to increase the font size
            ul: '<ul class="multiselect-container dropdown-menu sc-multiselect-control-md-ul"></ul>',
            li: '<li><a href="javascript:void(0);"><label><span class="jix-multiselect-radiobutton"></span></label></a></li>'
        }
    });

    $('#companyname').jix_select2({
        minimumInputLength: 1,
        ajax: {
            url: '/api/suggestions/cv-data',
            dataType: 'json',
            data: function (params) {
                return {
                    q:  params.term,
                    type: 'jobhistory_companies'
                };
            },
            delay: 250,
            processResults: function (data) {
                const res = [];
                $.each(data.result, function (i, v) {
                    res.push({ id: v.value, text: v.value });
                });
                return { results: res };
            },
            cache: true
        },
        tags: true,
        createTag: function (query) {
            return { id: query.term, text: query.term };
        }
    });
});
